import "./spinner.css";

function Spinner() {
  return (
    <div className="flex-center h-screen">
      <img className="spinner-rotate" src="/assets/img/brand/logo_icon.png" width={80} alt="" />
    </div>
  );
}

export default Spinner;
